<h1 class="mat-dialog-title">Create New Tag</h1>
<div mat-dialog-content>
    <!-- CREATE TAG: NAME -->
    <div class="form-group">
        <mat-form-field>
            <input
                matInput
                placeholder="Name"
                [(ngModel)]="tagName"
                name="name"
                #name="ngModel"
                required
            >
        </mat-form-field>
    </div>
</div>
<div
    class="mat-dialog-actions"
    align="center"
>
    <button
        tabindex="-1"
        mat-dialog-close
        mat-raised-button
        color="basic"
        class="mat-button-medium"
    >
        Cancel
    </button>
    <button
        mat-raised-button
        color="primary"
        class="mat-button-medium"
        [mat-dialog-close]="true"
        [disabled]="!tagName || tagName?.length === 0"
        (click)="createNewTag()"
    >
        Done
    </button>
</div>
